@if (order$ | async; as order) {
  <div class="cx-order-items px-0">
    <h4 class="cx-order-items-header">
      {{ 'checkoutOrderConfirmation.orderItems' | cxTranslate }}
    </h4>
    @if (orderPromotions$ | async; as orderPromotions) {
      <cx-promotions [promotions]="orderPromotions"></cx-promotions>
    }
    <app-efa-cart-item-list [items]="order.entries"
      [readonly]="true"
      [fromConfigurator]="order.fromConfigurator"
    [promotionLocation]="promotionLocation"></app-efa-cart-item-list>
  </div>
}
